import api from './api';
import { getAccessToken } from './authService';

// Function to fetch user details using access token
const getAppConfig = async () => {

  try {

    const accessToken = getAccessToken();
    if(accessToken == null){
      return false;
    }

    if (!accessToken) {
      throw new Error('Access token not found');
    }

    const response = await api.get('/config/get_config');

    // console.log(response.data.result.app_config)

    return response?.data?.result?.app_config;

  } catch (error) {

    console.log(error)

    console.error('Fetch app config error:', error);
    throw error;
  }
};

export { getAppConfig };
